import React from "react";
import { Helmet } from "react-helmet";

const HeadTitle = ({ title, icon }) => {
  return (
    <div>
      <Helmet>
        <title>{title}</title>
        <link rel="icon" href={icon} />
      </Helmet>
    </div>
  );
};

export default HeadTitle;
